import { ref, onMounted, onUnmounted, } from 'vue';

const useElementVisible = (element) => {
  const isVisible = ref(false);

  const check = () => {
    if (element) {
      const boundingBox = element.getBoundingClientRect();
      const { top, left, right, bottom } = boundingBox;
      isVisible.value =
        top <= window.innerHeight &&
        left <= window.innerWidth &&
        bottom >= 0 &&
        right >= 0;
    } else {
      isVisible.value = false;
    }
  };

  const startWatching = () => {
    if (element) {
      check();
      window.addEventListener('scroll', check);
      window.addEventListener('resize', check);
    }
  };
  setTimeout(() => {
    check();
  }, 1000);

  startWatching(); // Start watching immediately
  onMounted(() => {
    check();
  });

  // Stop watching when the component is unmounted
  onUnmounted(() => {
    window.removeEventListener('scroll', check);
  });


// Start watching immediately
startWatching();

  return isVisible ;
};

export default useElementVisible;